import ChalkySticks from '@chalkysticks/sdk';

/**
 * Whether scroll manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Initialize scroll event listeners.
 *
 * @return void
 */
export function initialize(): void {
	if (hasInitialized) {
		return;
	}

	ChalkySticks.Core.Event.Bus.on('scrollToTop', (e: ChalkySticks.Core.IDispatcherEvent<any>) => {
		scrollTo(0, 0, e.data.smooth);
	});

	ChalkySticks.Core.Event.Bus.on('scrollToBottom', (e: ChalkySticks.Core.IDispatcherEvent<any>) => {
		scrollTo(0, 99999, e.data.smooth);
	});

	hasInitialized = true;
}

/**
 * Scroll the main layout element to specified position.
 *
 * @param number x
 * @param number y
 * @param boolean smooth
 * @return void
 */
function scrollTo(x: number = 0, y: number = 0, smooth: boolean): void {
	const layoutElement = document.querySelector('[class*="page-"]');

	if (layoutElement) {
		if (smooth) {
			layoutElement.scrollTo({
				behavior: 'smooth',
				top: y,
			});
		} else {
			layoutElement.scrollTo(x, y);
		}
	}
}
